
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };

    try {


isNotRegistered('aad-generic') && (binding.modules['aad-generic'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-aad-generic' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/aad-generic/aad-generic'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'aad-generic',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/aad-generic'
});
        

isNotRegistered('accordion') && (binding.modules['accordion'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-accordion-accordion' */
        '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion/accordion'),
    $type: 'moduleDefinition',
    da: [{name:'accordionExpandedState',  path:'@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'accordion',
    p: 'accordion',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion'
});
        

isNotRegistered('accordion-item') && (binding.modules['accordion-item'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-accordion-accordion-item' */
        '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion-item/accordion-item'),
    $type: 'moduleDefinition',
    da: [{name:'accordionExpandedState',  path:'@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'accordion-item',
    p: 'accordion',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion-item'
});
        

isNotRegistered('account-address-tile') && (binding.modules['account-address-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-address-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-address-tile/account-address-tile'),
    $type: 'contentModule',
    da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-address-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-address-tile'
});
        

isNotRegistered('account-customer-balance') && (binding.modules['account-customer-balance'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-customer-balance' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance/account-customer-balance'),
    $type: 'contentModule',
    da: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'balance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-customer-balance',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance'
});
        

isNotRegistered('account-customer-balance-tile') && (binding.modules['account-customer-balance-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-customer-balance-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance-tile/account-customer-balance-tile'),
    $type: 'contentModule',
    da: [{name:'balance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-customer-balance-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance-tile'
});
        

isNotRegistered('account-generic-tile') && (binding.modules['account-generic-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-generic-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-generic-tile/account-generic-tile'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-generic-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-generic-tile'
});
        

isNotRegistered('account-invoice-tile') && (binding.modules['account-invoice-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-invoice-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-invoice-tile/account-invoice-tile'),
    $type: 'contentModule',
    da: [{name:'customerBalance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'invoices',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-invoice-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-invoice-tile'
});
        

isNotRegistered('account-loyalty') && (binding.modules['account-loyalty'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-loyalty' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty/account-loyalty'),
    $type: 'contentModule',
    da: [{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-loyalty',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty'
});
        

isNotRegistered('account-loyalty-tile') && (binding.modules['account-loyalty-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-loyalty-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty-tile/account-loyalty-tile'),
    $type: 'contentModule',
    da: [{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-loyalty-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty-tile'
});
        

isNotRegistered('account-management-address') && (binding.modules['account-management-address'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-address-account-management-address' */
        '@msdyn365-commerce-modules/address/dist/lib/modules/account-management-address/account-management-address'),
    $type: 'contentModule',
    da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-management-address',
    p: 'address',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/account-management-address'
});
        

isNotRegistered('account-order-templates-tile') && (binding.modules['account-order-templates-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-order-templates-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-order-templates-tile/account-order-templates-tile'),
    $type: 'contentModule',
    da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 1},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-order-templates-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-order-templates-tile'
});
        

isNotRegistered('account-profile') && (binding.modules['account-profile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-profile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile/account-profile'),
    $type: 'contentModule',
    da: [{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-profile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile'
});
        

isNotRegistered('account-profile-edit') && (binding.modules['account-profile-edit'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-profile-edit' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile-edit/account-profile-edit'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-profile-edit',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile-edit'
});
        

isNotRegistered('account-welcome-tile') && (binding.modules['account-welcome-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-welcome-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-welcome-tile/account-welcome-tile'),
    $type: 'contentModule',
    da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-welcome-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-welcome-tile'
});
        

isNotRegistered('account-wishlist-tile') && (binding.modules['account-wishlist-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-wishlist-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-wishlist-tile/account-wishlist-tile'),
    $type: 'contentModule',
    da: [{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'account-wishlist-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-wishlist-tile'
});
        

isNotRegistered('b2b-requests-status') && (binding.modules['b2b-requests-status'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-b2b-requests-status' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-status/b2b-requests-status'),
    $type: 'contentModule',
    da: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'operationRequests',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-business-partner-operation-requests', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'b2b-requests-status',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-status'
});
        

isNotRegistered('b2b-requests-tile') && (binding.modules['b2b-requests-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-b2b-requests-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-tile/b2b-requests-tile'),
    $type: 'contentModule',
    da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'b2b-requests-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-tile'
});
        

isNotRegistered('back-top-footer') && (binding.modules['back-top-footer'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-footer-back-top-footer' */
        '@msdyn365-commerce-modules/footer/dist/lib/modules/back-top-footer/back-top-footer'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'back-top-footer',
    p: 'footer',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/back-top-footer'
});
        

isNotRegistered('breadcrumb') && (binding.modules['breadcrumb'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-breadcrumb-breadcrumb' */
        '@msdyn365-commerce-modules/breadcrumb/dist/lib/modules/breadcrumb/breadcrumb'),
    $type: 'contentModule',
    da: [{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'categoryPaths',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'breadcrumb',
    p: 'breadcrumb',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/breadcrumb/dist/lib/modules/breadcrumb'
});
        

isNotRegistered('business-account-address') && (binding.modules['business-account-address'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-address-business-account-address' */
        '@msdyn365-commerce-modules/address/dist/lib/modules/business-account-address/business-account-address'),
    $type: 'contentModule',
    da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'business-account-address',
    p: 'address',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/business-account-address'
});
        

isNotRegistered('business-organization-list') && (binding.modules['business-organization-list'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-business-organization-list-business-organization-list' */
        '@msdyn365-commerce-modules/business-organization-list/dist/lib/modules/business-organization-list/business-organization-list'),
    $type: 'contentModule',
    da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'users',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'business-organization-list',
    p: 'business-organization-list',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/business-organization-list/dist/lib/modules/business-organization-list'
});
        

isNotRegistered('business-sign-up') && (binding.modules['business-sign-up'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-business-account-management-business-sign-up' */
        '@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up'),
    $type: 'containerModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'business-sign-up',
    p: 'business-account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up'
});
        

isNotRegistered('buybox') && (binding.modules['buybox'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-buybox-buybox' */
        '@msdyn365-commerce-modules/buybox/dist/lib/modules/buybox/buybox'),
    $type: 'containerModule',
    da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productAvailableQuantity',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant', runOn: 0},{name:'productDimensions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant', runOn: 0},{name:'productPrice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant', runOn: 0},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'buybox',
    p: 'buybox',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/buybox/dist/lib/modules/buybox'
});
        

isNotRegistered('carousel') && (binding.modules['carousel'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-carousel-carousel' */
        '@msdyn365-commerce-modules/carousel/dist/lib/modules/carousel/carousel'),
    $type: 'containerModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'carousel',
    p: 'carousel',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/carousel/dist/lib/modules/carousel'
});
        

isNotRegistered('cart') && (binding.modules['cart'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-cart-cart' */
        '@msdyn365-commerce-modules/cart/dist/lib/modules/cart/cart'),
    $type: 'containerModule',
    da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0},{name:'productAvailabilites',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlistItems',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'cart',
    p: 'cart',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/cart/dist/lib/modules/cart'
});
        

isNotRegistered('cart-icon') && (binding.modules['cart-icon'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-cart-cart-icon' */
        '@msdyn365-commerce-modules/cart/dist/lib/modules/cart-icon/cart-icon'),
    $type: 'containerModule',
    da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'cart-icon',
    p: 'cart',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/cart/dist/lib/modules/cart-icon'
});
        

isNotRegistered('category-page-summary') && (binding.modules['category-page-summary'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-page-summary-category-page-summary' */
        '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary'),
    $type: 'htmlHeadTagsModule',
    da: [{name:'pageSummary',  path:'@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'category-page-summary',
    p: 'page-summary',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary'
});
        

isNotRegistered('check-in-for-pickup') && (binding.modules['check-in-for-pickup'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-check-in-for-pickup-check-in-for-pickup' */
        '@msdyn365-commerce-modules/check-in-for-pickup/dist/lib/modules/check-in-for-pickup/check-in-for-pickup'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'check-in-for-pickup',
    p: 'check-in-for-pickup',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/check-in-for-pickup/dist/lib/modules/check-in-for-pickup'
});
        

isNotRegistered('checkout') && (binding.modules['checkout'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/checkout'),
    $type: 'containerModule',
    da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout'
});
        

isNotRegistered('checkout-billing-address') && (binding.modules['checkout-billing-address'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-address-checkout-billing-address' */
        '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-billing-address/checkout-billing-address'),
    $type: 'contentModule',
    da: [{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-billing-address',
    p: 'address',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/checkout-billing-address'
});
        

isNotRegistered('checkout-customer-account-payment') && (binding.modules['checkout-customer-account-payment'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-customer-account-payment' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-customer-account-payment/checkout-customer-account-payment'),
    $type: 'contentModule',
    da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'creditBalances',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-customer-account-payment',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-customer-account-payment'
});
        

isNotRegistered('checkout-delivery-options') && (binding.modules['checkout-delivery-options'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-delivery-options' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-delivery-options/checkout-delivery-options'),
    $type: 'contentModule',
    da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-delivery-options',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-delivery-options'
});
        

isNotRegistered('checkout-gift-card') && (binding.modules['checkout-gift-card'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-gift-card' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-gift-card/checkout-gift-card'),
    $type: 'contentModule',
    da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-gift-card',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-gift-card'
});
        

isNotRegistered('checkout-guest-profile') && (binding.modules['checkout-guest-profile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-guest-profile' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-guest-profile/checkout-guest-profile'),
    $type: 'contentModule',
    da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-guest-profile',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-guest-profile'
});
        

isNotRegistered('checkout-loyalty') && (binding.modules['checkout-loyalty'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-loyalty' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-loyalty/checkout-loyalty'),
    $type: 'contentModule',
    da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'loyaltyTransactionEstimation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-transaction-estimation', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-loyalty',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-loyalty'
});
        

isNotRegistered('checkout-order-confirmation') && (binding.modules['checkout-order-confirmation'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-order-management-checkout-order-confirmation' */
        '@msdyn365-commerce-modules/order-management/dist/lib/modules/checkout-order-confirmation/checkout-order-confirmation'),
    $type: 'contentModule',
    da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-order-confirmation',
    p: 'order-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/checkout-order-confirmation'
});
        

isNotRegistered('checkout-payment-instrument') && (binding.modules['checkout-payment-instrument'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-payment-instrument' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/checkout-payment-instrument'),
    $type: 'contentModule',
    da: [{name:'cardPaymentAcceptPoint',  path:'@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-payment-instrument',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument'
});
        

isNotRegistered('checkout-pickup') && (binding.modules['checkout-pickup'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-pickup' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-pickup/checkout-pickup'),
    $type: 'contentModule',
    da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-pickup',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-pickup'
});
        

isNotRegistered('checkout-section-container') && (binding.modules['checkout-section-container'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-section-container' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-section-container/checkout-section-container'),
    $type: 'containerModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-section-container',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-section-container'
});
        

isNotRegistered('checkout-shipping-address') && (binding.modules['checkout-shipping-address'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-address-checkout-shipping-address' */
        '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-shipping-address/checkout-shipping-address'),
    $type: 'contentModule',
    da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-shipping-address',
    p: 'address',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/checkout-shipping-address'
});
        

isNotRegistered('checkout-terms-and-conditions') && (binding.modules['checkout-terms-and-conditions'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-terms-and-conditions' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-terms-and-conditions/checkout-terms-and-conditions'),
    $type: 'contentModule',
    da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'checkout-terms-and-conditions',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-terms-and-conditions'
});
        

isNotRegistered('content-block') && (binding.modules['content-block'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-content-block-content-block' */
        '@msdyn365-commerce-modules/content-block/dist/lib/modules/content-block/content-block'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'content-block',
    p: 'content-block',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/content-block/dist/lib/modules/content-block'
});
        

isNotRegistered('cookie-compliance') && (binding.modules['cookie-compliance'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-cookie-compliance-cookie-compliance' */
        '@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'cookie-compliance',
    p: 'cookie-compliance',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance'
});
        

isNotRegistered('default-container') && (binding.modules['default-container'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-default-container' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container/default-container'),
    $type: 'containerModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'default-container',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container'
});
        

isNotRegistered('default-container-2-slots') && (binding.modules['default-container-2-slots'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-default-container-2-slots' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-2-slots/default-container-2-slots'),
    $type: 'containerModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'default-container-2-slots',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-2-slots'
});
        

isNotRegistered('default-container-3-slots') && (binding.modules['default-container-3-slots'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-default-container-3-slots' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-3-slots/default-container-3-slots'),
    $type: 'containerModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'default-container-3-slots',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-3-slots'
});
        

isNotRegistered('default-external-script') && (binding.modules['default-external-script'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-default-external-script' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-external-script/default-external-script'),
    $type: 'scriptModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'default-external-script',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-external-script'
});
        

isNotRegistered('default-inline-script') && (binding.modules['default-inline-script'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-default-inline-script' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-inline-script/default-inline-script'),
    $type: 'scriptModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'default-inline-script',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-inline-script'
});
        

isNotRegistered('default-metatags') && (binding.modules['default-metatags'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-default-metatags' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-metatags/default-metatags'),
    $type: 'htmlHeadTagsModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'default-metatags',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-metatags'
});
        

isNotRegistered('default-page') && (binding.modules['default-page'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-default-page' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-page/default-page'),
    $type: 'pageModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'default-page',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-page'
});
        

isNotRegistered('default-page-summary') && (binding.modules['default-page-summary'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-page-summary-default-page-summary' */
        '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary'),
    $type: 'htmlHeadTagsModule',
    da: [{name:'pageSummary',  path:'@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'default-page-summary',
    p: 'page-summary',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary'
});
        

isNotRegistered('fabrikam') && (binding.modules['fabrikam'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-fabrikam' */
        '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/fabrikam'),
    $type: 'themeModule',
    da: [],
    definitionExtensions: ['buybox','content-block','media-gallery','navigation-menu','promo-banner','text-block'],
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'fabrikam',
    p: 'fabrikam-design-kit',
    
    pdp: '',
    
    themeSettings: 'fabrikam.theme.settings.json',
    md: 'node_modules/@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam'
});
        

isNotRegistered('footer-category') && (binding.modules['footer-category'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-footer-footer-category' */
        '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-category/footer-category'),
    $type: 'containerModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'footer-category',
    p: 'footer',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/footer-category'
});
        

isNotRegistered('footer-item') && (binding.modules['footer-item'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-footer-footer-item' */
        '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-item/footer-item'),
    $type: 'moduleDefinition',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'footer-item',
    p: 'footer',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/footer-item'
});
        

isNotRegistered('gift-card-balance-check') && (binding.modules['gift-card-balance-check'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-checkout-gift-card-balance-check' */
        '@msdyn365-commerce-modules/checkout/dist/lib/modules/gift-card-balance-check/gift-card-balance-check'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'gift-card-balance-check',
    p: 'checkout',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/gift-card-balance-check'
});
        

isNotRegistered('header') && (binding.modules['header'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-header-header' */
        '@msdyn365-commerce-modules/header/dist/lib/modules/header/header'),
    $type: 'containerModule',
    da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'header',
    p: 'header',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/header/dist/lib/modules/header'
});
        

isNotRegistered('iframe') && (binding.modules['iframe'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-iframe-iframe' */
        '@msdyn365-commerce-modules/iframe/dist/lib/modules/iframe/iframe'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'iframe',
    p: 'iframe',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/iframe/dist/lib/modules/iframe'
});
        

isNotRegistered('invoice-details') && (binding.modules['invoice-details'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-invoice-details-invoice-details' */
        '@msdyn365-commerce-modules/invoice-details/dist/lib/modules/invoice-details/invoice-details'),
    $type: 'contentModule',
    da: [{name:'invoice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice', runOn: 0},{name:'invoiceDetails',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'invoice-details',
    p: 'invoice-details',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/invoice-details/dist/lib/modules/invoice-details'
});
        

isNotRegistered('invoices-list') && (binding.modules['invoices-list'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-invoice-invoices-list' */
        '@msdyn365-commerce-modules/invoice/dist/lib/modules/invoices-list/invoices-list'),
    $type: 'contentModule',
    da: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'customerBalance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'invoices',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'invoices-list',
    p: 'invoice',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/invoice/dist/lib/modules/invoices-list'
});
        

isNotRegistered('list-page-summary') && (binding.modules['list-page-summary'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-page-summary-list-page-summary' */
        '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary'),
    $type: 'htmlHeadTagsModule',
    da: [{name:'pageSummary',  path:'@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'list-page-summary',
    p: 'page-summary',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary'
});
        

isNotRegistered('loyalty-sign-up') && (binding.modules['loyalty-sign-up'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-loyalty-sign-up' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-sign-up/loyalty-sign-up'),
    $type: 'contentModule',
    da: [{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'loyalty-sign-up',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-sign-up'
});
        

isNotRegistered('loyalty-terms') && (binding.modules['loyalty-terms'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-loyalty-terms' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-terms/loyalty-terms'),
    $type: 'containerModule',
    da: [{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'loyalty-terms',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-terms'
});
        

isNotRegistered('map') && (binding.modules['map'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-map-map' */
        '@msdyn365-commerce-modules/map/dist/lib/modules/map/map'),
    $type: 'contentModule',
    da: [{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'map',
    p: 'map',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/map/dist/lib/modules/map'
});
        

isNotRegistered('media-gallery') && (binding.modules['media-gallery'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-media-gallery-media-gallery' */
        '@msdyn365-commerce-modules/media-gallery/dist/lib/modules/media-gallery/media-gallery'),
    $type: 'contentModule',
    da: [{name:'mediaLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'media-gallery',
    p: 'media-gallery',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/media-gallery/dist/lib/modules/media-gallery'
});
        

isNotRegistered('navigation-menu') && (binding.modules['navigation-menu'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-navigation-menu-navigation-menu' */
        '@msdyn365-commerce-modules/navigation-menu/dist/lib/modules/navigation-menu/navigation-menu'),
    $type: 'contentModule',
    da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'navigation-menu',
    p: 'navigation-menu',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/navigation-menu/dist/lib/modules/navigation-menu'
});
        

isNotRegistered('notifications-list') && (binding.modules['notifications-list'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-notifications-lists-notifications-list' */
        '@msdyn365-commerce-modules/notifications-lists/dist/lib/modules/notifications-list/notifications-list'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'notifications-list',
    p: 'notifications-lists',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/notifications-lists/dist/lib/modules/notifications-list'
});
        

isNotRegistered('order-confirmation') && (binding.modules['order-confirmation'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-confirmation' */
        '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-confirmation/order-confirmation'),
    $type: 'contentModule',
    da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'orderHydration',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations', runOn: 0},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'order-confirmation',
    p: 'order-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-confirmation'
});
        

isNotRegistered('order-details') && (binding.modules['order-details'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-details' */
        '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-details/order-details'),
    $type: 'contentModule',
    da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'orderHydration',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'order-details',
    p: 'order-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-details'
});
        

isNotRegistered('order-history') && (binding.modules['order-history'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history' */
        '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history/order-history'),
    $type: 'contentModule',
    da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'order-history',
    p: 'order-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history'
});
        

isNotRegistered('order-template') && (binding.modules['order-template'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-order-template-order-template' */
        '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/order-template'),
    $type: 'contentModule',
    da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'orderTemplate',  path:'@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/actions/get-order-template', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'order-template',
    p: 'order-template',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template'
});
        

isNotRegistered('order-template-list') && (binding.modules['order-template-list'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-order-template-order-template-list' */
        '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template-list/order-template-list'),
    $type: 'contentModule',
    da: [{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'order-template-list',
    p: 'order-template',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template-list'
});
        

isNotRegistered('organization-users-tile') && (binding.modules['organization-users-tile'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-organization-users-tile' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/organization-users-tile/organization-users-tile'),
    $type: 'contentModule',
    da: [{name:'users',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users-count', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'organization-users-tile',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/organization-users-tile'
});
        

isNotRegistered('password-reset') && (binding.modules['password-reset'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-password-reset' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset/password-reset'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'password-reset',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset'
});
        

isNotRegistered('password-reset-verification') && (binding.modules['password-reset-verification'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-password-reset-verification' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset-verification/password-reset-verification'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'password-reset-verification',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset-verification'
});
        

isNotRegistered('place-holder-for-container-preview') && (binding.modules['place-holder-for-container-preview'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-place-holder-for-container-preview' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/place-holder-for-container-preview/place-holder-for-container-preview'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'place-holder-for-container-preview',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/place-holder-for-container-preview'
});
        

isNotRegistered('product-collection') && (binding.modules['product-collection'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-product-collection-product-collection' */
        '@msdyn365-commerce-modules/product-collection/dist/lib/modules/product-collection/product-collection'),
    $type: 'containerModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'product-collection',
    p: 'product-collection',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/product-collection/dist/lib/modules/product-collection'
});
        

isNotRegistered('product-page-summary') && (binding.modules['product-page-summary'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-page-summary-product-page-summary' */
        '@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary'),
    $type: 'htmlHeadTagsModule',
    da: [{name:'productPageSummary',  path:'@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'product-page-summary',
    p: 'page-summary',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary'
});
        

isNotRegistered('product-specification') && (binding.modules['product-specification'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-product-specification-product-specification' */
        '@msdyn365-commerce-modules/product-specification/dist/lib/modules/product-specification/product-specification'),
    $type: 'contentModule',
    da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'product-specification',
    p: 'product-specification',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/product-specification/dist/lib/modules/product-specification'
});
        

isNotRegistered('promo-banner') && (binding.modules['promo-banner'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-promo-banner-promo-banner' */
        '@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner/promo-banner'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'promo-banner',
    p: 'promo-banner',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner'
});
        

isNotRegistered('quick-order') && (binding.modules['quick-order'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-quick-order-quick-order' */
        '@msdyn365-commerce-modules/quick-order/dist/lib/modules/quick-order/quick-order'),
    $type: 'contentModule',
    da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'quick-order',
    p: 'quick-order',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/quick-order/dist/lib/modules/quick-order'
});
        

isNotRegistered('quickview') && (binding.modules['quickview'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-buybox-quickview' */
        '@msdyn365-commerce-modules/buybox/dist/lib/modules/quickview/quickview'),
    $type: 'containerModule',
    da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'quickview',
    p: 'buybox',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/buybox/dist/lib/modules/quickview'
});
        

isNotRegistered('ratings-histogram') && (binding.modules['ratings-histogram'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-ratings-histogram' */
        '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/ratings-histogram/ratings-histogram'),
    $type: 'contentModule',
    da: [{name:'ratingsReviewsState',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action', runOn: 1},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'ratings-histogram',
    p: 'ratings-reviews',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/ratings-histogram'
});
        

isNotRegistered('reviews-list') && (binding.modules['reviews-list'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-reviews-list' */
        '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/reviews-list/reviews-list'),
    $type: 'contentModule',
    da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'ratingsReviewsState',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action', runOn: 1},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 0},{name:'reviewsList',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-product-reviews', runOn: 0},{name:'userReview',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'reviews-list',
    p: 'ratings-reviews',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/reviews-list'
});
        

isNotRegistered('script-injector') && (binding.modules['script-injector'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-core-components-script-injector' */
        '@msdyn365-commerce-modules/core-components/dist/lib/modules/script-injector/script-injector'),
    $type: 'scriptModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'script-injector',
    p: 'core-components',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/script-injector'
});
        

isNotRegistered('search') && (binding.modules['search'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-search-search' */
        '@msdyn365-commerce-modules/search/dist/lib/modules/search/search'),
    $type: 'contentModule',
    da: [{name:'searchState',  path:'@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'search',
    p: 'search',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/search/dist/lib/modules/search'
});
        

isNotRegistered('search-result-container') && (binding.modules['search-result-container'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-search-result-container-search-result-container' */
        '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/search-result-container'),
    $type: 'containerModule',
    da: [{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'featureProduct',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'listPageState',  path:'@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/list-page-state', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-mapped-search-configuration', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'search-result-container',
    p: 'search-result-container',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container'
});
        

isNotRegistered('sign-in') && (binding.modules['sign-in'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-sign-in' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in/sign-in'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'sign-in',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in'
});
        

isNotRegistered('sign-up') && (binding.modules['sign-up'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-account-management-sign-up' */
        '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up/sign-up'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'sign-up',
    p: 'account-management',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up'
});
        

isNotRegistered('site-picker') && (binding.modules['site-picker'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-site-picker-site-picker' */
        '@msdyn365-commerce-modules/site-picker/dist/lib/modules/site-picker/site-picker'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'site-picker',
    p: 'site-picker',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/site-picker/dist/lib/modules/site-picker'
});
        

isNotRegistered('social-share') && (binding.modules['social-share'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-social-share-social-share' */
        '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share/social-share'),
    $type: 'moduleDefinition',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'social-share',
    p: 'social-share',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share'
});
        

isNotRegistered('social-share-item') && (binding.modules['social-share-item'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-social-share-social-share-item' */
        '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share-item/social-share-item'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'social-share-item',
    p: 'social-share',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share-item'
});
        

isNotRegistered('spacer') && (binding.modules['spacer'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-spacer-spacer' */
        '@msdyn365-commerce-modules/spacer/dist/lib/modules/spacer/spacer'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'spacer',
    p: 'spacer',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/spacer/dist/lib/modules/spacer'
});
        

isNotRegistered('starter') && (binding.modules['starter'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-starter-theme-pack-starter' */
        '@msdyn365-commerce-modules/starter-theme-pack/dist/lib/modules/starter/starter'),
    $type: 'themeModule',
    da: [],
    definitionExtensions: ['content-block','promo-banner','text-block'],
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'starter',
    p: 'starter-theme-pack',
    
    pdp: '',
    
    themeSettings: 'starter.theme.settings.json',
    md: 'node_modules/@msdyn365-commerce-modules/starter-theme-pack/dist/lib/modules/starter'
});
        

isNotRegistered('store-selector') && (binding.modules['store-selector'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-store-selector-store-selector' */
        '@msdyn365-commerce-modules/store-selector/dist/lib/modules/store-selector/store-selector'),
    $type: 'contentModule',
    da: [{name:'availabilitiesWithHours',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby', runOn: 1},{name:'storeLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'store-selector',
    p: 'store-selector',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/store-selector/dist/lib/modules/store-selector'
});
        

isNotRegistered('tab') && (binding.modules['tab'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-tab-tab' */
        '@msdyn365-commerce-modules/tab/dist/lib/modules/tab/tab'),
    $type: 'moduleDefinition',
    da: [{name:'activeTabState',  path:'@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'tab',
    p: 'tab',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/tab/dist/lib/modules/tab'
});
        

isNotRegistered('tab-item') && (binding.modules['tab-item'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-tab-tab-item' */
        '@msdyn365-commerce-modules/tab/dist/lib/modules/tab-item/tab-item'),
    $type: 'moduleDefinition',
    da: [{name:'activeTabState',  path:'@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'tab-item',
    p: 'tab',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/tab/dist/lib/modules/tab-item'
});
        

isNotRegistered('text-block') && (binding.modules['text-block'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-text-block-text-block' */
        '@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block/text-block'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'text-block',
    p: 'text-block',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block'
});
        

isNotRegistered('video-player') && (binding.modules['video-player'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-video-player-video-player' */
        '@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player/video-player'),
    $type: 'contentModule',
    da: [],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'video-player',
    p: 'video-player',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player'
});
        

isNotRegistered('wishlist-items') && (binding.modules['wishlist-items'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-wishlist-wishlist-items' */
        '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/wishlist-items'),
    $type: 'contentModule',
    da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'productAvailability',  path:'@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-product-availabilities-wishlist-items', runOn: 1},{name:'products',  path:'@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-items-in-wishlists', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'wishlist-items',
    p: 'wishlist',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items'
});
        

isNotRegistered('write-review') && (binding.modules['write-review'] = {
    c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
            
            /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
            /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-write-review' */
        '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/write-review/write-review'),
    $type: 'contentModule',
    da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'userReview',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review', runOn: 0}],
    
    iNM: true,
    ns: '@msdyn365-commerce-modules',
    n: 'write-review',
    p: 'ratings-reviews',
    
    pdp: '',
    
    
    md: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/write-review'
});
        

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/addToCart-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/addToCart-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/copyCart-checkOut-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/copyCart-checkOut-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/getById-product-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/getById-product-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/getByIds-product-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/getByIds-product-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/getVariantsByDimensionValues-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/getVariantsByDimensionValues-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/purchase-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/purchase-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/readCart-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/readCart-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/removeFromCart-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/removeFromCart-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/updateCart-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/updateCart-telemetry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('accordion')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('accordion-item')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-address-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-address-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-customer-balance')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-customer-balance')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-customer-balance')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-customer-balance-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-customer-balance-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-invoice-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-invoice-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-loyalty')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-loyalty-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-management-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-management-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-management-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-management-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-order-templates-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-order-templates-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-order-templates-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-profile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-profile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-welcome-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-wishlist-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-requests-status')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-business-partner-operation-requests';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-business-partner-operation-requests');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-requests-status')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-requests-status')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-requests-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('breadcrumb')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('breadcrumb')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('breadcrumb')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-account-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-account-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-account-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-account-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-organization-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-organization-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('category-page-summary')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action';
            let dataAction = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart';
            let dataAction = require('@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-customer-account-payment')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-customer-account-payment')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-customer-account-payment')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-gift-card')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-loyalty')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-loyalty')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-transaction-estimation';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-transaction-estimation');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-loyalty')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/actions/get-card-payment-accept-point';
            let dataAction = require('@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-terms-and-conditions')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('default-page-summary')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action';
            let dataAction = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('header')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('header')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('header')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('invoice-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('invoice-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('invoices-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('invoices-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('invoices-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('invoices-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('list-page-summary')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action';
            let dataAction = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('loyalty-sign-up')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('loyalty-terms')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('map')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('media-gallery')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('media-gallery')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('navigation-menu')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-template')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/actions/get-order-template';
            let dataAction = require('@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/actions/get-order-template');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-template')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-template-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('organization-users-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users-count';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users-count');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-page-summary')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action';
            let dataAction = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-specification')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-specification')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('quick-order')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('quick-order')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('quick-order')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('quickview')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('quickview')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('quickview')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('ratings-histogram')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('ratings-histogram')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-product-reviews';
            let dataAction = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-product-reviews');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review';
            let dataAction = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-full-products-by-collection';
            let dataAction = require('@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-mapped-search-configuration';
            let dataAction = require('@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-refiners-for-collection';
            let dataAction = require('@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/list-page-state';
            let dataAction = require('@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('store-selector')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('store-selector')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('store-selector')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('tab')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('tab-item')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-items-in-wishlists';
            let dataAction = require('@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-items-in-wishlists');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-product-availabilities-wishlist-items';
            let dataAction = require('@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-product-availabilities-wishlist-items');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('write-review')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review';
            let dataAction = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('write-review')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};